'use client';

import Container from '@/components/layout/Container';

function IframeEmbed({ block }) {
  const iFrameSrc = block?.iframe_embed?.iframe_source || '';

  /*
   * IframeEmbed component will just be used for the Mattress Quiz for now
   */
  function handleJebbit() {
    function embedJebbit(t) {
      function e(t) {
        var e =
          'attach' === t ? window.addEventListener : window.removeEventListener;
        (e('DOMContentLoaded', i, !1),
          e('load', i, !1),
          e('scroll', i, !1),
          e('resize', i, !1));
      }
      var n = document.querySelector(t);
      function i() {
        (function (t) {
          var e = t.getBoundingClientRect(),
            n = t.clientHeight / 2,
            i = t.clientWidth / 2;
          return (
            e.top >= 0 &&
            e.left >= 0 &&
            e.top <=
              (window.innerHeight || document.documentElement.clientHeight) -
                n &&
            e.left <=
              (window.innerWidth || document.documentElement.clientWidth) - i
          );
        })(n) && n.contentWindow?.postMessage('startJebbitCampaign', '*');
      }
      (window.addEventListener(
        'message',
        function (t) {
          t &&
            ('jebbitSessionCreated' === t.data
              ? e('remove')
              : 'jebbitCampaignLoaded' === t.data
                ? i()
                : t.data &&
                  'redirect' === t.data.action &&
                  t.data.options &&
                  t.data.options.link &&
                  (window.location.href = t.data.options.link));
        },
        !1
      ),
        e('attach'));
    }
    embedJebbit('.jebbit-iframe');
  }

  return (
    <Container>
      <iframe
        className="jebbit-iframe"
        title="Leesa Mattress Quiz"
        src={iFrameSrc}
        seamless={true}
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen={true}
        style={{ width: '100%', minHeight: '750px' }}
        onLoad={handleJebbit}
      />
    </Container>
  );
}

export default IframeEmbed;
